import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=3d119854&"
import script from "./AutomationList.vue?vue&type=script&lang=js&"
export * from "./AutomationList.vue?vue&type=script&lang=js&"
import style0 from "./AutomationList.vue?vue&type=style&index=0&id=3d119854&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports